import { AxiosPromise } from 'axios';
import { urlHelper } from 'src/app/helpers';
import { axiosc } from 'src/app/utils';
import { urlsConfig } from 'src/configs';
import { queryTypes, servicesMuhabereCihaziTuruTypes } from 'src/types';

export const muharebeCihazlariLookup = ({
  limit,
  load,
  offset,
  ids,
  value,
  order,
  sortOrder,
  blockSpinner,
}: servicesMuhabereCihaziTuruTypes.MuhabereCihaziTuruLookupDataType): AxiosPromise<servicesMuhabereCihaziTuruTypes.MuhabereCihaziTuruLookupResultType> => {
  const query: queryTypes.LookupQueryParametersType = {};

  if (ids) {
    query.ids = ids.join(',');
  }

  if (value) {
    query.search = value;
  }

  if (order && sortOrder) {
    query.order = order;
    query.sortOrder = sortOrder;
  }

  if (limit && offset) {
    query.limit = limit;
    query.offset = offset;
  }

  if (load) {
    query.load = load.join(',');
  }

  return axiosc.get(urlHelper.addQueryParameters(query, urlsConfig.generics.common.muhabereCihaziTuru), {
    blockSpinner,
  });
};
